module.exports = __webpack_public_path__ + "img/edit-alt-1.43564451.svg";